import { DeleteOutlined, PlusCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import ActionHeader from "../../../components/ActionHeader";
import BaseTable from "../../../components/BaseTable";
import usePageState from "../../../hooks/usePageState";
import { useState } from "react";
import useModal from "../../../hooks/useModal";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import useConfirmAction from "../../../hooks/useConfirmAction";
import { Tag } from "antd";
import { LIMIT_PER_PAGE, SALE_VALUE_TYPE_ENUM } from "../../../../applications/constants/AppConst";
import { VoucherResponse } from "../../../../infrastructure/model/VoucherModel";
import CreateVoucherDialog from "./CreateVoucherDialog";
import { isArray } from "lodash";
import {
  deleteVoucherUseCase,
  getAllVoucherUseCase,
} from "../../../../applications/useCase/ApiUseCase/VoucherApiUseCase";

function Vouchers() {
  const [listVoucher, setListVoucher] = useState<VoucherResponse[]>([]);
  const { isLoading, setLoading, showSuccess, showError } = usePageState();
  const [createModal, openCreateModal] = useModal();
  const [selectedItem, setSelectedItem] = useState<VoucherResponse>();

  const { dialog: confirmDeleteDialog, confirm: confirmDelete } = useConfirmAction({
    onConfirm(params) {
      handleDeleteItem();
    },
  });
  const [total, setTotal] = useState<number>(0);

  const [filter, setFilter] = useState({
    page: 1,
    limit: LIMIT_PER_PAGE,
  });

  async function getListVoucher() {
    const res = await getAllVoucherUseCase({
      params: filter,
      setLoading,
      showError,
    });
    if (res) {
      setListVoucher(res.data);
      setTotal(res.total);
    }
  }

  async function handleDeleteItem() {
    if (!selectedItem?.id) return;

    const res = await deleteVoucherUseCase({
      voucherId: selectedItem.id,
      setLoading,
      showError,
      showSuccess,
    });
    if (res) {
      setListVoucher(listVoucher.filter((e) => e.id !== selectedItem.id));
      setSelectedItem(undefined);
    }
  }

  async function handleOpenCreateDialog(updateItem?: VoucherResponse) {
    const result = await openCreateModal<VoucherResponse>((close) => {
      return <CreateVoucherDialog onClose={close} updateItem={updateItem} />;
    });
    if (result && isArray(result)) {
      // if (updateItem) {
      //   const indexUpdate = listVoucher.findIndex((e) => e.id === updateItem.id);
      //   setListVoucher([
      //     ...listVoucher.slice(0, indexUpdate),
      //     result,
      //     ...listVoucher.slice(indexUpdate + 1),
      //   ]);
      //   setSelectedItem(result);
      // } else {
      setListVoucher([...result, ...listVoucher]);
      // }
    }
  }

  useAsyncEffect(async () => {
    await getListVoucher();
  }, [filter.page]);

  return (
    <div className="h-100 flex flex-column">
      <ActionHeader
        actions={[
          {
            icon: <ReloadOutlined />,
            isNormal: true,
            userClick: getListVoucher,
            type: "primary",
          },
          {
            icon: <PlusCircleOutlined />,
            isNormal: true,
            userClick: handleOpenCreateDialog,
            type: "primary",
          },
          // {
          //   icon: <EditOutlined />,
          //   isNormal: true,
          //   userClick: () => handleOpenCreateDialog(selectedItem),
          //   disabled: !selectedItem?.id,
          //   type: "primary",
          // },
          {
            isNormal: true,
            userClick: confirmDelete,
            icon: <DeleteOutlined />,
            disabled: !selectedItem?.id,
            color: "danger",
            variant: "outlined",
          },
        ]}
      />
      <BaseTable
        dataSource={listVoucher}
        columns={[
          {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 50,
          },
          {
            title: "Code",
            dataIndex: "code",
            key: "code",
            width: 200,
          },
          {
            title: "Trạng thái",
            dataIndex: "is_active",
            key: "is_active",
            width: 100,
            render(value, record, index) {
              return (
                <Tag color={value ? "#108ee9" : "#f50"}>
                  {value ? "Hoạt động" : "Không hoạt động"}
                </Tag>
              );
            },
          },
          {
            title: "Giảm giá",
            dataIndex: "discount_value",
            key: "discount_value",
            width: 100,
            render(value, record, index) {
              return `${record.discount_value} (${
                record.discount_type === SALE_VALUE_TYPE_ENUM.VND ? "đ" : "%"
              })`;
            },
          },
          {
            title: "Số lượng áp dụng",
            dataIndex: "applicable_user_count",
            key: "applicable_user_count",
            width: 100,
            render(value, record, index) {
              return `${record.applied_user_count} / ${record.applicable_user_count}`;
            },
          },
          {
            title: "Ngày bắt đầu",
            dataIndex: "start_date",
            key: "start_date",
            width: 100,
            render(value, record, index) {
              return new Date(value).toLocaleDateString("vi-VN");
            },
          },
          {
            title: "Ngày kết thúc",
            dataIndex: "end_date",
            key: "end_date",
            width: 100,
            render(value, record, index) {
              return new Date(value).toLocaleDateString("vi-VN");
            },
          },
        ]}
        rowKey={"id"}
        rowSelection={{
          type: "radio",
          selectedRowKeys: selectedItem?.id ? [selectedItem.id] : [],
          onSelect(record) {
            setSelectedItem(record);
          },
        }}
        loading={isLoading}
        pagination={{
          total: total,
          current: filter.page,
          pageSize: filter.limit,
          onChange(page, pageSize) {
            setFilter({ ...filter, page });
          },
        }}
      />
      {createModal}
      {confirmDeleteDialog}
    </div>
  );
}
export default Vouchers;
